import states from '../components/USStates.json';

export default interface IState {
    name: string;
    abbreviation: string;
}

export class State implements IState {
    name: string;
    abbreviation: string;


    getStateFromAbbrv = (abrv: string): string => {
        const index = states.findIndex((item: IState) => item.abbreviation === abrv);
        if (index >= 0 ) {
          return states[index].name;
        } else {
            return abrv;
        }
    }

    constructor(abrv: string) {
        this.abbreviation = abrv;
        this.name = this.getStateFromAbbrv(abrv);
    }
}